export default String.raw`
{% include 'partials/common/date-format.html' -%}
<article class="blog-item">
    {% assign sizePost=include.Content | StripHtml | Size | Minus: 4 -%}
    <a tabindex="-1" href="{{ page.BaseHref }}{{ include.Url }}" class="not-focusable-js">
        <div class="blog-item__img">
            {% if include.ImageUrl -%}
                <img src="{{ include.ImageUrl }}" alt="{{ include.ImageAlt }}" title="{{ include.ImageTitle }}" loading="eager" fetchpriority="high">
            {% else -%}
                <img src="css/img/img-placeholder.jpg" alt="{{ include.Heading }}" loading="eager" fetchpriority="high">
            {% endif %}
        </div>
        <h3 class="blog-item__title">{{ include.Heading }}</h3>
        <p class='blog-item__content'>{{ include.Content | StripHtml | Slice: 0,sizePost }}</p>
    </a>
    <div class="blog-item__read">
        <div class="blog-item__read-top">
            <time datetime="{{ include.PublishedDate | Date: 'yyyy-MM-dd HH:mm:ss' }}">{{ include.PublishedDate | Date:dateFormat }}</time>
            <div class="blog-item__read-top-tags">
                {% for tag in include.Tags -%}
                    {% if tag.Text != "" %}
                        <a href="{{ page.BaseHref }}{{ tag.Url }}">#{{ tag.Text }}</a>
                    {% else -%}
                        &nbsp;
                    {% endif %}
                {% endfor -%}
            </div>
        </div>
        <div class="blog-item__read-bottom">
            <div class="blog-item__read-bottom-time">
                <span>
                    ~ {{ include.ReadTime }} {{ translations.ReadTime }}
                </span>
            </div>
            <div class="blog-item__read-bottom-button">
                <a href="{{ page.BaseHref }}{{ include.Url }}">
                    {{translations.ReadMore}} <svg><use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{ settings.iconStyle }}'></use></svg>
                </a>
            </div>
        </div>
    </div>
</article>
`